export function generatePDFName(companyName, invoiceNumber) {
    // Replace commas and periods with underscores, then replace spaces with underscores
    const cleanedName = companyName
        .replace(/[,.]/g, "_") // Replace commas and periods with underscores
        .replace(/\s+/g, "_") // Replace one or more spaces with single underscore
        .replace(/_+/g, "_") // Replace multiple consecutive underscores with single underscore
        .replace(/^_|_$/g, ""); // Remove leading and trailing underscores

    // Combine cleaned company name with invoice number
    return `${cleanedName}-${invoiceNumber}`;
}

export function formatEUR(num) {
    const formatted = new Intl.NumberFormat("sl-SI", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(num);
    return formatted;
}